import React from 'react'

const VaultIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 4.99998C13 4.4477 12.5523 3.99998 12 3.99998C11.4477 3.99998 11 4.4477 11 4.99998V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V4.99998Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default VaultIcon
